export const GET_DEVICE_COUNT = "GET_DEVICE_COUNT"
export const GET_DEVICE_COUNT_ERR = "GET_DEVICE_COUNT_ERR"
